import api from "./api";

export const notificationService = {
  // Lấy danh sách thông báo với phân trang và filters
  getNotifications: async (pageNumber = 1, pageSize = 20, filters = {}) => {
    try {
      const params = new URLSearchParams({
        pageNumber: pageNumber.toString(),
        pageSize: pageSize.toString(),
      });

      // Thêm các filters nếu có
      if (filters.search) params.append("search", filters.search);
      if (filters.priority) params.append("priority", filters.priority);
      if (filters.type) params.append("type", filters.type);
      if (filters.isRead !== undefined && filters.isRead !== "") {
        params.append("isRead", filters.isRead);
      }

      const response = await api.get(`/notifications?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching notifications:", error);
      throw error;
    }
  },

  // Lấy số lượng thông báo chưa đọc
  getUnreadCount: async () => {
    try {
      const response = await api.get("/notifications/unread-count");
      return response.data;
    } catch (error) {
      console.error("Error fetching unread count:", error);
      throw error;
    }
  },

  // Đánh dấu thông báo đã đọc
  markAsRead: async (notificationId) => {
    try {
      const response = await api.put(
        `/notifications/${notificationId}/mark-read`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking notification as read:", error);
      throw error;
    }
  },

  // Đánh dấu tất cả thông báo đã đọc
  markAllAsRead: async () => {
    try {
      const response = await api.put("/notifications/mark-all-read");
      return response.data;
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
      throw error;
    }
  },

  // Xóa thông báo
  deleteNotification: async (notificationId) => {
    try {
      const response = await api.delete(`/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting notification:", error);
      throw error;
    }
  },

  // Đánh dấu nhiều thông báo (đã đọc hoặc chưa đọc)
  updateReadStatus: async (notificationIds, isRead) => {
    try {
      const response = await api.put("/notifications/bulk-mark-read", {
        notificationIds,
        isRead,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating notification status:", error);
      throw error;
    }
  },

  // Xóa nhiều thông báo
  deleteNotifications: async (notificationIds) => {
    try {
      const response = await api.delete("/notifications/bulk-delete", {
        data: { notificationIds },
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting notifications:", error);
      throw error;
    }
  },

  // Tạo thông báo (chỉ admin)
  createNotification: async (notificationData) => {
    try {
      const response = await api.post("/notifications", notificationData);
      return response.data;
    } catch (error) {
      console.error("Error creating notification:", error);
      throw error;
    }
  },
};
